import { Instagram, Facebook } from "lucide-react";
import { useBuyGuide } from "../hooks/useBuyGuide";

// Minimal inline SVG for Threads – lucide-react doesn't ship a consistent icon.
const ThreadsIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M17.5 8c-1-2-3-3.5-5.5-3.5C8 4.5 5 7 5 12s3 7.5 7 7.5c2.5 0 4.5-1.2 5.5-3 .7-1.3.7-3.2-.5-4.3-1-.9-2.5-1.2-4-1.2-2.5 0-4 1-4 2.5 0 1.3 1.2 2 2.5 2 2 0 3-1.5 3-4" />
  </svg>
);

const TikTokIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5" />
  </svg>
);

const SOCIALS = [
  {
    key: "instagram",
    label: "Instagram",
    href: "https://www.instagram.com/findauraventures",
    Icon: Instagram,
  },
  {
    key: "tiktok",
    label: "TikTok",
    href: "https://www.tiktok.com/@findauraventures",
    Icon: TikTokIcon,
  },
  {
    key: "threads",
    label: "Threads",
    href: "https://www.threads.net/@findauraventures",
    Icon: ThreadsIcon,
  },
  {
    key: "facebook",
    label: "Facebook",
    href: "https://www.facebook.com/profile.php?id=61584087020311",
    Icon: Facebook,
  },
];

export default function Footer() {
  const { loading: buyLoading, buyGuide } = useBuyGuide();
  return (
    <footer
      data-testid="footer-section"
      className="pt-24 md:pt-32 pb-10 px-6 md:px-12 lg:px-20 border-t border-[#1A1A1A]/10"
      style={{ background: "#FAF9F6" }}
    >
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center">
          <span className="overline">Findaura Ventures</span>
          <h3
            className="font-serif font-light tracking-tighter leading-none mt-6 text-[18vw] md:text-[13vw] lg:text-[11vw]"
            data-testid="footer-brand"
          >
            FIND<em className="italic text-[#C28C55]">aura</em>
          </h3>
          <p className="mt-6 font-serif italic text-2xl md:text-3xl text-[#5C5A56]">
            The future is automated — and fabulous.
          </p>

          {/* Buy Now – final soft close */}
          <div className="mt-12 flex flex-col items-center gap-3">
            <button
              onClick={buyGuide}
              disabled={buyLoading}
              className="btn-primary"
              data-testid="footer-buy-now"
            >
              {buyLoading ? "Opening Checkout…" : "Buy the Soft Life AI Guide"}
              <span aria-hidden>→</span>
            </button>
            <span className="overline" style={{ color: "#5C5A56" }}>$27 · Secure Stripe checkout</span>
          </div>
        </div>

        <div className="mt-16 md:mt-24 grid grid-cols-1 md:grid-cols-3 gap-8 items-end">
          <div>
            <span className="overline block">Elsewhere</span>
            <div className="mt-4 flex items-center gap-6 flex-wrap">
              {SOCIALS.map(({ key, label, href, Icon }) => (
                <a
                  key={key}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group flex items-center gap-3 text-sm transition-colors duration-300"
                  style={{ color: "#1A1A1A" }}
                  data-testid={`footer-${key}`}
                  aria-label={label}
                >
                  <span
                    className="inline-flex items-center justify-center transition-transform duration-500"
                    style={{ color: "#C28C55" }}
                  >
                    <Icon width={18} height={18} size={18} />
                  </span>
                  <span className="group-hover:text-[#C28C55] transition-colors duration-300">{label}</span>
                </a>
              ))}
            </div>
          </div>
          <div className="text-center">
            <span className="overline block">Contact</span>
            <a
              href="mailto:info@findarua.com"
              className="mt-4 inline-block font-serif italic text-lg hover:text-[#C28C55] transition-colors"
              data-testid="footer-email"
            >
              info@findarua.com
            </a>
          </div>
          <div className="md:text-right">
            <span className="overline block">© 2026</span>
            <p className="mt-4 text-sm text-[#5C5A56]">All rights reserved. Made with quiet care.</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
